// src/pages/ChatScreen.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import Sidebar from '../../components/Chat/Sidebar';
import ChatWindow from '../../components/Chat/ChatWindow';
import './Chat.css';
import './ChatRefresh.css';

import { useAuth } from "../../contexts/AuthContext";

const ChatScreen = () => {
  const { currentUser } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const [activeRoom, setActiveRoom] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // 1. Get ad context from the navigation state (if it exists)
  const adContext = location.state?.adContext;

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const initChat = async () => {
      if (!adContext || !currentUser) return;

      const { adId, adTitle, sellerId, sellerName, sellerImage } = adContext;
      const ids = [currentUser.uid, sellerId].sort();
      const chatRoomId = `${adId}_${ids[0]}_${ids[1]}`;

      const roomRef = doc(db, 'chat_rooms', chatRoomId);
      const roomSnap = await getDoc(roomRef);

      const roomData = {
        id: chatRoomId,
        adId,
        adTitle,
        participantIds: ids,
        participantInfo: {
          [currentUser.uid]: { name: currentUser.displayName, image: currentUser.photoURL },
          [sellerId]: { name: sellerName, image: sellerImage }
        }
      };

      if (!roomSnap.exists()) {
        await setDoc(roomRef, {
          ...roomData,
          hasMessages: false,
          lastMessageText: '',
          lastMessageTimestamp: serverTimestamp(),
        });
      }

      setActiveRoom(roomData);
    };

    initChat();
  }, [adContext, currentUser]);

  return (
    <div className="chat-page-bg">
      <div className="chat-outer-container">

        {/* SIDEBAR */}
        {(!isMobileView || !activeRoom) && (
          <Sidebar
            currentUser={currentUser}
            onSelectRoom={setActiveRoom}
            selectedRoomId={activeRoom?.id}
          />
        )}

        {/* CHAT WINDOW */}
        {(!isMobileView || activeRoom) && (
          <ChatWindow
            currentUser={currentUser}
            room={activeRoom}
            onBack={() => setActiveRoom(null)} // 🔥 important
          />
        )}

        {/* <ChatWindow
          currentUser={currentUser}
          room={activeRoom}
          onBack={() => navigate('/')}
        /> */}
      </div>
    </div>
  );
};

export default ChatScreen;
